"use client";
import { CRUDFetchParams, DataListParams, DataListProp } from "@/components/layout/layoutType";
import * as dc from "@/components/layout/list/defaultType";
import {
  copyFormValue,
  focusFormField,
  getFormMemo,
  runFormFunction,
  setFormMemo,
  setSubListDisplay,
} from "@/components/layout/input/inputFunction";
import { Debug } from "@/util/debug";
import dayjs, { locale } from "dayjs";
import { getCheckData, getDcOptions, getFormValues, getMissList, setFormValues } from "@/components/layout/list/defaultTypeCheck";
import { getChangeValues, getCheckedInfoDataStr, getCodeStringObj, getInfoDataStr, setFormConvertValues } from "@/util/tableCodeCreater";
import { equals, objEquals } from "@/util/arrayutil";
import { DataColumnField } from "../../input/inputType";
import { AlertContext } from "@/components/context/alertContext";
import { useContext } from "react";
import { checkEmpty } from "@/util/stringutil";
import { koLocale } from "@/i18n/routing";

export function SystemResult(props: DataListProp): DataListParams | undefined {
  const t = props.t;
  const ta = props.ta;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const setSubData = props.setSubData;
  const formFunction = props.formFunction;
  const alertContext = props.alertContext;
  const alert_p = alertContext?.setProp; //params?.alertFunction;
  const result = props.result;

  const emptyFetch: CRUDFetchParams = { fetchUrl: "" };
  // const result: DataListParams = {
  //   user: params?.user,
  //   page: params?.page,
  //   locale: params?.locale,
  //   pathname: params?.menu?.pathname,
  //   dataFetch: emptyFetch,
  //   listFetch: emptyFetch,
  //   alertFunction: alert_p, //params?.alertFunction,
  //   pageAuth: params?.pageAuth,
  //   setTimer: params?.setTimer,
  // };
  const utcOffset = dayjs().utcOffset() * 60000;

  const result_params = { t, ta, result, params, form, formMemo, setValueList, formFunction };

  const list = [
    "system_TABLE_SCHEMA",
    "system_TABLE_NAME",
    "system_table_pk",
    "system_table_manual_increment",
    "system_table_page",
    "system_table_path",
    "system_table_page_name",
    "system_table_auth",
    "system_select_auth",
    "system_cafe_auth",
    "system_cafe_auth_field",
    "system_roaster_auth",
    "system_roaster_auth_field",
    "system_table_mapper",
    "system_table_detail_result",
    "system_table_search_column",
    "system_table_search_select",
    "system_table_order_column",
    "system_table_default_name_column",
    "system_table_en_name_column",
    "system_table_use_column",
  ];
  const uncheck = [
    "system_table_pk",
    "system_table_manual_increment",
    "system_table_auth",
    "system_select_auth",
    "system_cafe_auth",
    "system_cafe_auth_field",
    "system_roaster_auth",
    "system_roaster_auth_field",
    "system_table_search_column",
    "system_table_search_select",
    "system_table_order_column",
    "system_table_default_name_column",
    "system_table_en_name_column",
    "system_table_use_column",
  ];
  const selectWithLoad = [
    "system_table_manual_increment",
    "system_cafe_auth_field",
    "system_roaster_auth_field",
    "system_table_search_column",
    "system_table_search_select",
    "system_table_order_column",
    "system_table_default_name_column",
    "system_table_en_name_column",
    "system_table_use_column",
  ];
  const table_column_select: DataColumnField = {
    inputClassName: dc.inputCountryClassName,
    selectPropOption: { reloadButton: false },
    dataUrl: "/api/setting/system/column",
    dataProp: {
      valueParam: { TABLE_SCHEMA: "system_TABLE_SCHEMA", TABLE_NAME: "system_TABLE_NAME" },
      requiredParam: ["TABLE_SCHEMA", "TABLE_NAME"],
    },
    dataLabel: {
      value: "COLUMN_NAME",
      label: ["COLUMN_NAME", "COLUMN_COMMENT"],
      labelSort: false,
    },
  };
  const system_table_pk_load = (data: any, value: any) => {
    if (formFunction?.current) {
      const { check_data, pri_key } = getCheckData(data);
      Debug("set orgSubListData", data, check_data);
      const org_data = JSON.parse(JSON.stringify(check_data));
      setFormMemo(formMemo?.current, "COLUMN_NAME", "orgSubListData", org_data);

      //아래에 추가 변경 값을 적용할 것
      const system_dc_input_text = ((form?.current?.getFieldValue("system_dc_input") as string) ?? "").trim();
      const info_str = getCheckedInfoDataStr(system_dc_input_text);

      //"system_TABLE_SCHEMA":"clm_greenbean","system_TABLE_NAME":"greenbean_default"
      const info_data = info_str ? JSON.parse(info_str) : undefined;

      if (info_data && info_data.table && info_data.change) {
        const check_fields = ["system_TABLE_SCHEMA", "system_TABLE_NAME"];
        const formValues = getFormValues(form?.current, ["system_TABLE_SCHEMA", "system_TABLE_NAME"]);
        const check = check_fields.every((item) => {
          return info_data.table[item] === formValues[item];
        });
        if (!check) {
          delete info_data.change;
        }
      }
      const changed = info_data?.change ? info_data.change : undefined;
      const sub_data = changed
        ? check_data.map((item: any) => {
            if (changed[item.COLUMN_NAME]) {
              Object.keys(changed[item.COLUMN_NAME]).forEach((key) => {
                item[key] = changed[item.COLUMN_NAME][key];
              });
            }
            return item;
          })
        : check_data;

      Debug(org_data, sub_data);
      const { run } = runFormFunction(formFunction.current, "COLUMN_NAME", "setSubListData", sub_data);
      if (run) {
        form?.current?.setFieldsValue({ system_table_pk: pri_key });
      }
      if (data.length > 20) {
        setTimeout(() => {
          runFormFunction(formFunction?.current, "COLUMN_NAME", "setLoading", false);
        }, dc.setTimeoutDelay);
      } else {
        runFormFunction(formFunction?.current, "COLUMN_NAME", "setLoading", false);
      }
    }
  };

  const system_dc_input_click = (e: any) => {
    const system_dc_input_text = ((form?.current?.getFieldValue("system_dc_input") as string) ?? "").trim();
    if (system_dc_input_text !== "") {
      try {
        const check_data = getCheckedInfoDataStr(system_dc_input_text);
        Debug(check_data);
        const info_obj = check_data ? JSON.parse(check_data) : JSON.parse(system_dc_input_text);
        const obj = info_obj.table;
        if (obj) {
          if (form?.current) setFormValues(form.current, obj);
          if (obj["system_TABLE_SCHEMA"] && formFunction?.current["system_TABLE_NAME"].changeLoad) {
            formFunction?.current["system_TABLE_NAME"].changeLoad();
          }
          if (obj["system_TABLE_NAME"] && formFunction?.current["system_table_pk"].changeLoad) {
            formFunction?.current["system_table_pk"].changeLoad((data: any, check_value: any) => {
              // Debug(data);
              // if (info_obj.change) {
              //   const convert = setFormConvertValues(
              //     form?.current,
              //     formMemo?.current,
              //     formFunction?.current,
              //     "COLUMN_NAME",
              //     info_obj.change,
              //   );
              //   Debug(info_obj.change, convert);
              // }
            });
          }
        }
      } catch (e) {
        Debug(e);
        alert("Parsing Error");
      }
    } else {
      const form_c = form?.current;
      const values = getFormValues(form_c, list);
      if (form_c) {
        if (Object.keys(values).length > 0) {
          Debug(values, Object.keys(values).length);
          const org = getFormMemo(formMemo?.current, "COLUMN_NAME", "orgSubListData");
          const { fields, changes, notChanges } = getChangeValues(form_c, values, org);
          const info = getInfoDataStr(values, changes);
          form_c.setFieldValue("system_dc_input", info + JSON.stringify(values));
        } else {
          const result = getMissList(Object.keys(dc));
          if (result.length > 0) {
            form_c.setFieldValue("system_dc_input", result.length > 0 ? '["' + result.join('",\r\n"') + '"]' : "");
          } else {
            // fetchHost("/api/codegroup/simple", dv.fetchOption, undefined, (data: any) => {
            //   Debug(data);
            // });
          }
        }
      }
    }
  };
  const system_code_create_click = () => {
    if (form?.current) {
      const form_c = form.current;
      const org = getFormMemo(formMemo?.current, "COLUMN_NAME", "orgSubListData");
      const value = getFormValues(form_c, list);
      const check = list.some((item) => {
        if (value[item] === undefined || value[item] === "") {
          if (uncheck.includes(item)) {
            return false;
          } else {
            const text = ta("field_required", { field: t(item) });
            alert(text);
            focusFormField(form?.current, item);
            return true;
          }
        } else {
          return false;
        }
      });
      Debug(value, org, check);
      if (org) {
        if (!check) {
          const obj = getCodeStringObj(form_c, value, org); //, values, fields, changeValues);
          form_c.setFieldsValue(obj);
        }
      }
    }
  };
  const system_code_clean_click = () => {
    if (form?.current) {
      const form_c = form.current;
      form_c.setFieldsValue({
        system_info_code: undefined,
        system_javascript_list: undefined,
        system_sql_common: undefined,
        system_sql_order: undefined,

        system_javascript_code: undefined,
        system_java_code: undefined,
        system_sql_query: undefined,
        system_excel_insert: undefined,
        system_excel_update: undefined,
      });
    }
  };

  const getCopyButton = (iconName: string, field: string): DataColumnField => {
    return {
      ...dc.buttonDefault(
        iconName,
        () => {
          copyFormValue(form?.current, field, t, ta);
        },
        "default",
        undefined,
        "ml-2 px-2",
      ),
      tooltip: field,
    };
  };

  switch (params?.page.page ?? "") {
    case "SettingTable":
      // const filePath = path.resolve(__dirname, "./defaultType.tsx");
      // const exports = analyzeExports(filePath);
      return {
        ...result,
        dataName: "SettingTable",
        dataFetch: {
          saveFetch: {
            //fetchUrl: "/api/roaster/create",
            successFunction: () => {
              if (sessionStorage !== undefined) {
                sessionStorage.removeItem("roaster_auth");
              }
              return "/roaster";
            },
          },
        },
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        dataCols: {
          system_dc_input: {
            ...dc.textAreaU,
            defaultValue:
              '    //--info--{\r\n    //--info--"table":{"system_TABLE_SCHEMA":"clm_greenbean","system_TABLE_NAME":"greenbean_default","system_table_pk":["greenbean_default_seq"],"system_table_page":"GreenbeanDefault","system_table_path":"setting/product/greenbeandefault","system_table_page_name":"SettingGreenbeanDefault","system_table_auth":["SADMIN","ADMIN"],"system_table_mapper":"product","system_table_detail_result":"detail_result","system_table_search_column":["greenbean_process","greenbean_variety_list","greenbean_country_code"],"system_table_search_select":["greenbean_name","greenbean_name_locale","greenbean_nick","greenbean_nick_locale"],"system_table_order_column":["greenbean_name","greenbean_name_locale","greenbean_nick","greenbean_nick_locale"],"system_table_default_name_column":"greenbean_name_locale","system_table_en_name_column":"greenbean_name"},\r\n    //--info--"change":{"greenbean_name":{"CHECK_LIST":["READ","CREATE","UPDATE","EXCEL_IN","EXCEL_UP"]},"greenbean_name_locale":{"CHECK_LIST":["READ","CREATE","UPDATE","EXCEL_IN","EXCEL_UP"]},"greenbean_nick":{"CHECK_LIST":["READ","CREATE","UPDATE","EXCEL_IN","EXCEL_UP"]}}\r\n    //--info--}',
            label: {
              element: "system_dc_input",
              elementType: "button",
              transition: true,
              buttonProp: {
                onClick: system_dc_input_click,
              },
            },
          },
          system_TABLE_SCHEMA: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/setting/system/schema",
            dataProp: {
              //fixedParam: { is_parent: true },
              //valueParam: { region_country: "greenbean_country_code" },
              //requiredParam: ["region_country"],
            },
            dataLabel: {
              value: "TABLE_SCHEMA",
              label: "TABLE_SCHEMA",
            },
            selectChangeLoad: "system_TABLE_NAME",
            //selectChangeDelay: 50,
            onChange: () => {
              form?.current?.setFieldsValue({ system_TABLE_NAME: undefined, system_table_pk: undefined });
            },
          },
          system_TABLE_NAME: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/setting/system/table",
            dataProp: {
              valueParam: { TABLE_SCHEMA: "system_TABLE_SCHEMA" },
              requiredParam: ["TABLE_SCHEMA"],
            },
            dataLabel: {
              value: "TABLE_NAME",
              label: ["TABLE_NAME", "TABLE_COMMENT"],
            },
            selectChangeLoad: "system_table_pk",
            selectChangeDelay: 100,
            onChange: () => {
              form?.current?.setFieldsValue({
                system_table_pk: undefined,
                system_table_search_column: undefined,
                system_table_search_select: undefined,
                system_table_order_column: undefined,
                system_table_default_name_column: undefined,
                system_table_en_name_column: undefined,
              });
            },
          },
          system_table_pk: {
            ...dc.selectSearchMulti,
            ...table_column_select,
            //disabled: true,
            selectPropOption: { reloadButton: true },
            dataProp: {
              ...table_column_select.dataProp,
              start: () => {
                runFormFunction(formFunction?.current, "COLUMN_NAME", "setLoading", true);
              },
              load: system_table_pk_load,
              error: (e: any) => {
                runFormFunction(formFunction?.current, "COLUMN_NAME", "setLoading", false);
              },
            },
            selectWithLoad: selectWithLoad,
            //readOnly: true,
          },
          system_table_manual_increment: {
            ...dc.selectSearch,
            ...table_column_select,
            selectFilter: { COLUMN_KEY: "PRI" },
          },

          system_table_page: { ...dc.inputFull, placeholder: "system_table_page_placeholder" }, //, maxLength: 300, showCount: true },
          system_table_page_name: { ...dc.inputFull, placeholder: "system_table_page_name_placeholder" }, //, maxLength: 300, showCount: true },
          system_table_path: { ...dc.inputFull, placeholder: "system_table_path_placeholder" }, //, maxLength: 300, showCount: true },
          system_table_mapper: { ...dc.inputFull, placeholder: "system_table_mapper_placeholder" }, //, maxLength: 300, showCount: true },
          system_table_detail_result: {
            ...dc.inputFull,
            defaultValue: "detail_result",
            placeholder: "system_table_detail_result_placeholder",
          },
          system_table_auth: {
            ...dc.selectSearchMulti,
            inputClassName: dc.inputCountryClassName,
            codeGroup: "USER",
            placeholder: "system_table_auth_placeholder",
          },
          system_select_auth: {
            ...dc.selectMulti,
            inputClassName: dc.inputCountryClassName,
            valueList: [
              { value: "cafe", label: "Cafe", label_str: "Cafe" },
              { value: "roaster", label: "Roaster", label_str: "Roaster" },
            ],
          },
          system_cafe_auth: {
            ...dc.select,
            codeGroup: "CAUTH",
          },
          system_cafe_auth_field: {
            ...dc.selectSearchMulti,
            ...table_column_select,
          },
          system_roaster_auth: {
            ...dc.select,
            codeGroup: "RAUTH",
          },
          system_roaster_auth_field: {
            ...dc.selectSearchMulti,
            ...table_column_select,
          },
          system_table_search_column: {
            ...dc.selectSearchMulti,
            ...table_column_select,
          },
          system_table_search_select: {
            ...dc.selectSearchMulti,
            ...table_column_select,
          },
          system_table_order_column: {
            ...dc.selectSearchMulti,
            ...table_column_select,
          },
          system_table_default_name_column: {
            ...dc.selectSearch,
            ...table_column_select,
          },
          system_table_en_name_column: {
            ...dc.selectSearch,
            ...table_column_select,
          },
          system_table_use_column: {
            ...dc.selectSearch,
            ...table_column_select,
          },
          system_code_group: {
            fieldId: {
              system_code_group_select: {
                ...dc.selectSearch,
                inputClassName: dc.inputCountryClassName,
                dataUrl: "/api/codegroup/simple",
                dataProp: {},
                dataLabel: {
                  value: "code_group_id",
                  label: ["code_group_id", params?.locale === koLocale ? "code_group_name_kr" : "code_group_name"],
                  labelSort: true,
                },
                onChange: (e) => {
                  form?.current?.setFieldValue("system_code_group_input", e.value);
                },
              },
              system_code_group_input: {
                ...dc.input,
                widthFull: false,
                inputClassName: "w-[7rem]",
              },
            },
          },
          COLUMN_NAME_EXPLAIN: {
            //label: "blank",
            label: {
              element: "TABLE_SHOW",
              elementType: "switch",
              transition: true,
              switchProp: {
                defaultValue: true,
                onChange: (e) => {
                  const tf = formFunction?.current["COLUMN_NAME"];
                  // if (tf && tf.setDisplay) {
                  //   tf.setDisplay(e);
                  // if (!e) {
                  //   setSubListDisplay(
                  //     formFunction?.current,
                  //     "COLUMN_NAME",
                  //     "COLUMN_CODE_SELECT_EXPLAIN",
                  //     "COLUMN_CODE_SELECT",
                  //     "COLUMN_COMMENT_EXPLAIN",
                  //     "COLUMN_COMMENT",
                  //   );
                  // }
                  // }
                },
              },
            },
            valueClassName: "flex-col lg:flex-row mobile_multi",
            //labelClassName: dc.mobileHidden,
            fieldId: {
              COLUMN_NAME_EXPLAIN_MAIN: {
                flexClassName: "COLUMN_NAME_MAIN",
                fieldId: {
                  DATA_TYPE_EXPLAIN: {
                    ...dc.input,
                    placeholder: "TABLE_DATA_TYPE",
                    widthFull: false,
                    allowClear: false,
                    inputClassName: "w-[7rem] text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  CHARACTER_MAXIMUM_LENGTH_EXPLAIN: {
                    ...dc.number,
                    placeholder: "TABLE_MAXIMUM_LENGTH",
                    allowClear: false,
                    inputClassName: "w-[4rem] input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  COLUMN_KEY_EXPLAIN: {
                    checkboxOption: [{ value: "PRI", label: undefined }],
                    defaultValue: ["PRI"],
                    tooltip: "TABLE_PRI_KEY",
                    //inputType: "checkbox",
                    elementProp: {
                      element: "P",
                      elementType: "button",
                      buttonProp: {
                        className: "w-6 pl-2 pr-0",
                        type: "text",
                      },
                    },
                    inputType: "element",
                    placeholder: "TABLE_IS_NULLABLE",
                    //disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  //IS_NULLABLE_SWITCH: { ...dc.useDefault, disabled: true },
                  IS_NULLABLE_EXPLAIN: {
                    checkboxOption: [{ value: "NO", label: undefined }],
                    defaultValue: ["NO"],
                    tooltip: "TABLE_NOT_NULL",
                    //inputType: "checkbox",
                    elementProp: {
                      element: "N",
                      elementType: "button",
                      buttonProp: {
                        className: "w-6 pl-2 pr-0",
                        type: "text",
                      },
                    },
                    inputType: "element",
                    placeholder: "TABLE_IS_NULLABLE",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  EXTRA_EXPLAIN: {
                    checkboxOption: [{ value: "auto_increment", label: undefined }],
                    defaultValue: ["auto_increment"],
                    tooltip: "TABLE_AUTO_INCREMENT",
                    //inputType: "checkbox",
                    elementProp: {
                      element: "A",
                      elementType: "button",
                      buttonProp: {
                        className: "w-6 pl-2 pr-0",
                        type: "text",
                      },
                    },
                    inputType: "element",
                    placeholder: "TABLE_IS_NULLABLE",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  IS_COMMENT_EXPLAIN: {
                    checkboxOption: [{ value: "auto_increment", label: undefined }],
                    defaultValue: ["auto_increment"],
                    //inputType: "checkbox",
                    elementProp: {
                      element: "C",
                      elementType: "button",
                      buttonProp: {
                        className: "w-6 pl-2 pr-0",
                        type: "text",
                      },
                    },
                    inputType: "element",
                    tooltip: "TABLE_COLUMN_COMMENT",
                    placeholder: "TABLE_COLUMN_COMMENT",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  COLUMN_DEFAULT_EXPLAIN: {
                    ...dc.input,
                    widthFull: false,
                    allowClear: false,
                    inputClassName: "w-[5rem] text-center",
                    placeholder: "TABLE_COLUMN_DEFAULT",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
              COLUMN_NAME_EXPLAIN_SUB: {
                flexClassName: "COLUMN_NAME_SUB w-full ml-0 mt-2 lg:ml-2 lg:mt-0",
                fieldId: {
                  //   COLUMN_COMMENT_EXPLAIN: {
                  //     ...dc.inputFull,
                  //     inputClassName: "input-text-center",
                  //     placeholder: "TABLE_COLUMN_COMMENT",
                  //     //disabled: true,
                  //     readOnly: true,
                  //     variant: "borderless",
                  //     noItem: true,
                  //     onClick: () => {
                  //       if (formFunction?.current) {
                  //         setSubListDisplay(
                  //           formFunction?.current,
                  //           "COLUMN_NAME",
                  //           "COLUMN_COMMENT_EXPLAIN",
                  //           "COLUMN_COMMENT",
                  //           "COLUMN_CODE_SELECT_EXPLAIN",
                  //           "COLUMN_CODE_SELECT",
                  //         );
                  //       }
                  //     },
                  //   },
                  COLUMN_TYPE_SELECT_EXPLAIN: {
                    ...dc.input,
                    widthFull: false,
                    allowClear: false,
                    inputClassName: "w-[8rem] text-center",
                    placeholder: "TABLE_COLUMN_TYPE_SELECT",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  COLUMN_CODE_SELECT_EXPLAIN: {
                    ...dc.input,
                    //display: "change",
                    widthFull: false,
                    allowClear: false,
                    inputClassName: "w-[10rem] text-center",
                    placeholder: "TABLE_COLUMN_CODE_SELECT",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                    // onClick: () => {
                    //   if (formFunction?.current) {
                    //     setSubListDisplay(
                    //       formFunction.current,
                    //       "COLUMN_NAME",
                    //       "COLUMN_CODE_SELECT_EXPLAIN",
                    //       "COLUMN_CODE_SELECT",
                    //       "COLUMN_COMMENT_EXPLAIN",
                    //       "COLUMN_COMMENT",
                    //     );
                    //   }
                    // },
                  },
                  CHECK_LIST_EXPLAIN: {
                    ...dc.input,
                    widthFull: false,
                    allowClear: false,
                    placeholder: "TABLE_CHECK_LIST",
                    inputClassName: "w-[9rem] text-center px-0",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
            },
          },

          COLUMN_NAME: {
            ...dc.inputFull,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            maxLength: 300,
            showCount: true,
            subList: { target: "column_list", labelField: "COLUMN_NAME" },
            ///display: "change",
            fieldId: {
              COLUMN_NAME_MAIN: {
                flexClassName: "COLUMN_NAME_MAIN",
                fieldId: {
                  DATA_TYPE: {
                    ...dc.input,
                    widthFull: false,
                    allowClear: false,
                    inputClassName: "w-[7rem]",
                    readOnly: true,
                    disabled: true,
                  },
                  CHARACTER_MAXIMUM_LENGTH: { ...dc.number, allowClear: false, inputClassName: "w-[4rem]", readOnly: true, disabled: true },
                  //IS_NULLABLE_SWITCH: { ...dc.useDefault, disabled: true },
                  COLUMN_KEY: {
                    checkboxOption: [{ value: "PRI", label: undefined }],
                    inputType: "checkbox",
                    disabled: true,
                    readOnly: true,
                  },
                  IS_NULLABLE: {
                    checkboxOption: [{ value: "NO", label: undefined }],
                    inputType: "checkbox",
                    disabled: true,
                    readOnly: true,
                  },
                  EXTRA: {
                    checkboxOption: [{ value: "auto_increment", label: undefined }],
                    inputType: "checkbox",
                    disabled: true,
                    readOnly: true,
                  },
                  IS_COMMENT: {
                    checkboxOption: [{ value: "YES", label: undefined }],
                    inputType: "checkbox",
                    tooltip: "COLUMN_COMMENT",
                    tooltipField: true,
                    disabled: true,
                    readOnly: true,
                  },
                  COLUMN_DEFAULT: {
                    ...dc.input,
                    widthFull: false,
                    allowClear: false,
                    inputClassName: "w-[5rem]",
                    readOnly: true,
                    disabled: true,
                  },
                },
              },
              COLUMN_NAME_SUB: {
                flexClassName: "COLUMN_NAME_SUB w-full ml-0 mt-2 lg:ml-2 lg:mt-0",
                fieldId: {
                  //COLUMN_COMMENT: { ...dc.inputFull, readOnly: true, disabled: true },
                  COLUMN_TYPE: {
                    ...dc.selectSearch,
                    valueList: [{ value: "", label: "선택안함", label_str: "선택안함" }, ...getDcOptions(Object.keys(dc))],
                    onChange: (e) => {
                      Debug(e);
                    },
                    inputClassName: "w-[8rem]",
                  },
                  COLUMN_CODE_SELECT: {
                    ...dc.selectSearch,
                    //display: "change",
                    inputClassName: "w-[10rem]",
                    dataUrl: "/api/codegroup/simple",
                    dataProp: {},
                    dataLabel: {
                      value: "code_group_id",
                      label: ["code_group_id", params?.locale === koLocale ? "code_group_name_kr" : "code_group_name"],
                      labelSort: true,
                    },
                    selectPropOption: { reloadButton: false },
                  },
                  CHECK_LIST: {
                    inputType: "checkbox",
                    inputClassName: "w-[9rem]",
                    checkboxOption: [
                      { label: undefined, value: "LIST" },
                      { label: undefined, value: "READ" },
                      { label: undefined, value: "CREATE" },
                      { label: undefined, value: "UPDATE" },
                      { label: undefined, value: "EXCEL_IN" },
                      { label: undefined, value: "EXCEL_UP" },
                    ],
                    onChange: (e) => {
                      // const temp_val = form?.current?.getFieldValue("IS_NULLABLE_0");
                      // const tf = formFunction?.current["IS_NULLABLE_0"];
                      // Debug(tf);
                      // if (tf && tf.setValue) {
                      //   if (temp_val === undefined || temp_val.length === 0) {
                      //     tf.setValue(["NO"]);
                      //   } else {
                      //     tf.setValue([]);
                      //   }
                      // }
                    },
                  },
                },
              },
              // LIST: { inputType: "checkbox" },
              // READ: { inputType: "checkbox" },
              // CREATE: { inputType: "checkbox" },
              // UPDATE: { inputType: "checkbox" },
              // EXCEL: { inputType: "checkbox" },
            },
          },

          system_code_create: {
            label: "blank",
            fieldId: {
              system_code_create: dc.textButton("ArticleNyTimes", "system_code_create", system_code_create_click, ""),
              system_code_clean: dc.textButton("Broom", "system_code_clean", system_code_clean_click),
              system_code_copy_info: getCopyButton("Info", "system_info_code"),
              system_code_copy_list: getCopyButton("ListMagnifyingGlass", "system_javascript_list"),
              system_code_copy_common: getCopyButton("CirclesThree", "system_sql_common"),
              system_code_copy_order: getCopyButton("ListNumbers", "system_sql_order"),
              system_code_copy_javascript: getCopyButton("FileJs", "system_javascript_code"),
              system_code_copy_java: getCopyButton("FileCode", "system_java_code"),
              system_code_copy_sql: getCopyButton("FileSql", "system_sql_query"),
              system_code_copy_excel_insert: getCopyButton("FileXls", "system_excel_insert"),
              system_code_copy_excel_update: getCopyButton("UploadSimple", "system_excel_update"),
            },
            checkUserType: ["SADMIN"],
          },
          system_info_code: { ...dc.textAreaU },
          system_javascript_list: { ...dc.textAreaU },
          system_sql_common: { ...dc.textAreaU },
          system_sql_order: { ...dc.textAreaU },
          system_javascript_code: { ...dc.textAreaU },
          system_java_code: { ...dc.textAreaU },
          system_sql_query: { ...dc.textAreaU },
          system_excel_insert: { ...dc.textAreaU },
          system_excel_update: { ...dc.textAreaU },
        },
        clipboard: {
          category: "SystemTable",
          inField: list,
          load: (obj) => {
            runFormFunction(formFunction?.current, "system_TABLE_NAME", "changeLoad");
            runFormFunction(formFunction?.current, "system_table_pk", "changeLoad");
          },
        },

        writeButton: false,
        saveButton: false,
        dataReloadButton: false,
        cancelButton: false,
      };
    case "CompareTable":
      return {
        ...result,
        dataName: "SettingTable",
        dataFetch: {
          saveFetch: {
            //fetchUrl: "/api/roaster/create",
            successFunction: () => {
              if (sessionStorage !== undefined) {
                sessionStorage.removeItem("roaster_auth");
              }
              return "/roaster";
            },
          },
        },
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        dataCols: {
          system_TABLE_SCHEMA: {
            fieldId: {
              system_TABLE_SCHEMA1: {
                ...dc.selectSearch,
                widthFull: true,
                inputClassName: "w-full",
                dataUrl: "/api/setting/system/schema",
                dataProp: {
                  //fixedParam: { is_parent: true },
                  //valueParam: { region_country: "greenbean_country_code" },
                  //requiredParam: ["region_country"],
                },
                dataLabel: {
                  value: "TABLE_SCHEMA",
                  label: "TABLE_SCHEMA",
                },
                selectChangeLoad: ["system_TABLE_NAME1", "system_TABLE_NAME2"],
                selectChangeDelay: 100,
                onChange: (e: any) => {
                  form?.current?.setFieldsValue({ system_TABLE_SCHEMA2: e.value });
                },
              },
              system_TABLE_SCHEMA2: {
                ...dc.selectSearch,
                widthFull: true,
                inputClassName: "w-full",
                dataUrl: "/api/setting/system/schema",
                dataProp: {
                  //fixedParam: { is_parent: true },
                  //valueParam: { region_country: "greenbean_country_code" },
                  //requiredParam: ["region_country"],
                },
                dataLabel: {
                  value: "TABLE_SCHEMA",
                  label: "TABLE_SCHEMA",
                },
                selectChangeLoad: "system_TABLE_NAME2",
                //selectChangeDelay: 50,
              },
            },
          },
          system_TABLE_NAME: {
            fieldId: {
              system_TABLE_NAME1: {
                ...dc.selectSearch,
                widthFull: true,
                inputClassName: "w-full",
                dataUrl: "/api/setting/system/table",
                dataProp: {
                  valueParam: { TABLE_SCHEMA: "system_TABLE_SCHEMA1" },
                  requiredParam: ["TABLE_SCHEMA"],
                },
                dataLabel: {
                  value: "TABLE_NAME",
                  label: ["TABLE_NAME", "TABLE_COMMENT"],
                },
                selectChangeLoad: "system_table_pk1",
                selectChangeDelay: 100,
              },
              system_TABLE_NAME2: {
                ...dc.selectSearch,
                widthFull: true,
                inputClassName: "w-full",
                dataUrl: "/api/setting/system/table",
                dataProp: {
                  valueParam: { TABLE_SCHEMA: "system_TABLE_SCHEMA2" },
                  requiredParam: ["TABLE_SCHEMA"],
                },
                dataLabel: {
                  value: "TABLE_NAME",
                  label: ["TABLE_NAME", "TABLE_COMMENT"],
                },
                selectChangeLoad: "system_table_pk2",
                selectChangeDelay: 100,
              },
            },
          },
          system_table_pk: {
            fieldId: {
              system_table_pk1: {
                ...dc.selectSearchMulti,
                ...table_column_select,
                inputClassName: "w-full",
                widthFull: true,
                //disabled: true,
                selectPropOption: { reloadButton: true },
                dataProp: {
                  ...table_column_select.dataProp,
                  load: (data: any, value: any) => {
                    if (form?.current) {
                      const { check_data, pri_key } = getCheckData(data);
                      form?.current?.setFieldsValue({ system_table_pk1: pri_key });
                    }
                  },
                  valueParam: { TABLE_SCHEMA: "system_TABLE_SCHEMA1", TABLE_NAME: "system_TABLE_NAME1" },
                  requiredParam: ["TABLE_SCHEMA", "TABLE_NAME"],
                },
                selectWithLoad: selectWithLoad,
                //readOnly: true,
              },
              system_table_pk2: {
                ...dc.selectSearchMulti,
                ...table_column_select,
                inputClassName: "w-full",
                widthFull: true,
                //disabled: true,
                selectPropOption: { reloadButton: true },
                dataProp: {
                  ...table_column_select.dataProp,
                  load: (data: any, value: any) => {
                    if (form?.current) {
                      const { check_data, pri_key } = getCheckData(data);
                      form?.current?.setFieldsValue({ system_table_pk2: pri_key });
                    }
                  },
                  valueParam: { TABLE_SCHEMA: "system_TABLE_SCHEMA2", TABLE_NAME: "system_TABLE_NAME2" },
                },
                selectWithLoad: selectWithLoad,
                //readOnly: true,
              },
            },
          },
          system_table_compare: {
            label: {
              element: "system_table_compare",
              elementType: "button",
              transition: true,
              buttonProp: {
                onClick: () => {
                  const data1 = getFormMemo(formMemo?.current, "system_table_pk1", "data");
                  const data2 = getFormMemo(formMemo?.current, "system_table_pk2", "data");
                  Debug(data1, data2);
                  if (data1 && data2 && data1.result && data2.result) {
                    const data1_list = data1.result;
                    const data2_list = data2.result;
                    if (data1_list instanceof Array && data2_list instanceof Array) {
                      let temp_field: string | undefined = undefined;
                      const data1_fields = data1_list.map((item) => {
                        if (temp_field) {
                          item.before = temp_field;
                        }
                        temp_field = item.COLUMN_NAME;
                        return item.COLUMN_NAME;
                      });
                      const data2_fields = data2_list.map((item) => {
                        if (temp_field) {
                          item.before = temp_field;
                        }
                        temp_field = item.COLUMN_NAME;
                        return item.COLUMN_NAME;
                      });
                      const data1_only = data1_list.filter((item) => {
                        return !data2_fields.includes(item.COLUMN_NAME);
                      });
                      const data2_only = data2_list.filter((item) => {
                        return !data1_fields.includes(item.COLUMN_NAME);
                      });
                      if (form?.current) {
                        const table_valus = getFormValues(form.current, [
                          "system_TABLE_SCHEMA1",
                          "system_TABLE_NAME1",
                          "system_TABLE_SCHEMA2",
                          "system_TABLE_NAME2",
                        ]);
                        const data1_table = `${table_valus.system_TABLE_SCHEMA1}.${table_valus.system_TABLE_NAME1}`;
                        const data2_table = `${table_valus.system_TABLE_SCHEMA2}.${table_valus.system_TABLE_NAME2}`;
                        form?.current?.setFieldsValue({
                          system_table_compare1: data1_only.map((item) => item.COLUMN_NAME).join("\r\n"),
                          system_table_compare2: data2_only.map((item) => item.COLUMN_NAME).join("\r\n"),
                          //TABLE_SCHEMA,TABLE_NAME,COLUMN_NAME,DATA_TYPE,ORDINAL_POSITION,COLUMN_DEFAULT,IS_NULLABLE,CHARACTER_MAXIMUM_LENGTH,COLUMN_KEY,EXTRA,COLUMN_COMMENT //"COLUMN_TYPE", "COLUMN_CODE_SELECT", "CHECK_LIST"

                          system_table_compare_sql1: data1_only
                            .map(
                              (item) =>
                                `ALTER TABLE ${data2_table} ADD COLUMN ${item.COLUMN_NAME} ${item.DATA_TYPE}${item.DATA_TYPE === "varchar" ? `(${item.CHARACTER_MAXIMUM_LENGTH})` : ""}${item.IS_NULLABLE === "NO" ? " NOT NULL" : ""}${checkEmpty(item.DEFAULT) ? (item.IS_NULLABLE !== "NO" ? " DEFAULT NULL" : "") : `DEFAULT '${item.DEFAULT}'`}${item.COLUMN_COMMENT ? ` COMMENT '${item.COLUMN_COMMENT}'` : ""}${item.before ? " AFTER " + item.before : ""};`,
                            )
                            .join("\r\n"),
                          system_table_compare_sql2: data2_only
                            .map(
                              (item) =>
                                `ALTER TABLE ${data1_table} ADD COLUMN ${item.COLUMN_NAME} ${item.DATA_TYPE}${item.DATA_TYPE === "varchar" ? `(${item.CHARACTER_MAXIMUM_LENGTH})` : ""}${item.IS_NULLABLE === "NO" ? " NOT NULL" : ""}${checkEmpty(item.DEFAULT) ? (item.IS_NULLABLE !== "NO" ? " DEFAULT NULL" : "") : `DEFAULT '${item.DEFAULT}'`}${item.COLUMN_COMMENT ? ` COMMENT '${item.COLUMN_COMMENT}'` : ""}${item.before ? " AFTER " + item.before : ""};`,
                            )
                            .join("\r\n"),
                        });
                      }
                    }
                  }
                },
              },
            },
            fieldId: {
              system_table_compare1: {
                ...dc.textAreaU,
              },
              system_table_compare2: {
                ...dc.textAreaU,
              },
            },
          },
          system_table_compare_sql: {
            label: "blank",
            fieldId: {
              system_table_compare_sql1: {
                ...dc.textAreaU,
              },
              system_table_compare_sql2: {
                ...dc.textAreaU,
              },
            },
          },
        },
        clipboard: {
          category: "CompareTable",
          exField: [
            "system_table_pk1",
            "system_table_pk2",
            "system_table_compare1",
            "system_table_compare2",
            "system_table_compare_sql1",
            "system_table_compare_sql2",
          ],
          load: (obj) => {
            runFormFunction(formFunction?.current, "system_TABLE_NAME1", "changeLoad");
            runFormFunction(formFunction?.current, "system_TABLE_NAME2", "changeLoad");
            runFormFunction(formFunction?.current, "system_table_pk1", "changeLoad");
            runFormFunction(formFunction?.current, "system_table_pk2", "changeLoad");
          },
        },
        writeButton: false,
        saveButton: false,
        dataReloadButton: false,
        cancelButton: false,
      };
    default:
      return undefined;
  }
}
